import { Assignment } from "@mui/icons-material";
import {
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useState } from "react";

import { SendQuestionnairesDialog } from "./SendQuestionnairesDialog";

export interface SendQuestionnairesIconButtonProps {
  patientReference: string | null;
  /** compact: só ícone; descriptive: botão com texto */
  variant?: "compact" | "descriptive";
  appointmentStatus?: string;
  /** Vínculo opcional com `Appointment` (mesmo `id` usado no CRM / WhatsApp). */
  appointmentReference?: string;
  hasActiveEncounter?: boolean;
}

/**
 * Botão/ícone na fila de agenda que abre o dialog de envio de questionários (Tasks no workflow).
 */
export function SendQuestionnairesTrigger({
  patientReference,
  variant = "compact",
  appointmentStatus,
  appointmentReference,
  hasActiveEncounter,
}: SendQuestionnairesIconButtonProps) {
  const [open, setOpen] = useState(false);

  const button = (
    <Tooltip title="Enviar questionários">
      <span>
        {variant === "compact" ? (
          <IconButton
            color="primary"
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              setOpen(true);
            }}
            disabled={!patientReference}
            aria-label="Enviar questionários ao paciente"
          >
            <Assignment fontSize="small" />
          </IconButton>
        ) : (
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<Assignment />}
            onClick={(event) => {
              event.stopPropagation();
              setOpen(true);
            }}
            disabled={!patientReference}
          >
            Questionários
          </Button>
        )}
      </span>
    </Tooltip>
  );

  return (
    <>
      {button}
      <SendQuestionnairesDialog
        open={open}
        onClose={() => setOpen(false)}
        patientReference={patientReference}
        appointmentStatus={appointmentStatus}
        appointmentReference={appointmentReference}
        hasActiveEncounter={hasActiveEncounter}
      />
    </>
  );
}
